export enum SetupFields {
    Practice = "practice",
    Doctor = "doctor"
}